import { useAppState } from "../context/StateContext";
import { Measurement } from "../models/measurement";
import { Metric } from "./converts";
import { MeasurementTypes } from "./enums";

export const DEFAULT_MEASUREMENT: Measurement = {
  type: MeasurementTypes.DIMENSIONS,
  description: "Cubic Meter",
  code: Metric["m³"],
  decimalPlaces: 2,
};

const DEFAULT_WEIGHT_MEASUREMENT: Measurement = {
  type: MeasurementTypes.WEIGHT,
  description: "Kilograms",
  code: Metric.kg,
  decimalPlaces: 2,
};

export function getMeasurement(measurement?: Measurement) {
  const { currentUser } = useAppState();

  return (
    measurement ||
    currentUser?.measurement ||
    currentUser?.company?.measurement ||
    DEFAULT_MEASUREMENT
  );
}

export function getWeightMeasurement(measurement?: Measurement) {
  const { currentUser } = useAppState();

  return (
    measurement ||
    currentUser?.measurementWeight ||
    currentUser?.company?.measurementWeight ||
    DEFAULT_WEIGHT_MEASUREMENT
  );
}

export function getCurrency() {
  const { currentUser } = useAppState();

  return currentUser?.company?.currency;
}
